import React, { useEffect, useState } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import ApiConnect from "../../../../Utils/ApiConnect";
import ReactDatatable from "@ashvin27/react-datatable";
import EditProduct from "./EditCategory";
import { useDispatch, useSelector } from "react-redux";
import DeletePop from "../../../Components/DeletePop";
import FileViewer from "../../../Components/FileViewer";
export default function ViewCategory() {
  const categoryList = useSelector((state) => state.Inventory.Category);
  const { url } = useRouteMatch();
  const dispatch = useDispatch();
  const [selectedId, SetselectedId] = useState(false);
  const [triggerModal, SettriggerModal] = useState(false);
  const [showModal, Setmodal] = useState(false);
  const [selectedFile, SetselectedFile] = useState(false);

  useEffect(() => {
    fetchHandler();
  }, []);
  const columns = [
    {
      key: "name",
      text: "Category Name",
      sortable: true,
      cell: (record) => {
        return (
          <div className="media d-inline-flex">
            <img
              className="avatar avatar-lg"
              src={record.image}
              alt={record.name}
              onClick={() => {
                SetselectedFile(record.image);
                Setmodal(true);
              }}
            />
            <div className="media-body">
              <p className="lh-1">{record.name}</p>
              <small>{record.catid}</small>
            </div>
          </div>
        );
      },
    },
    {
      key: "product",
      text: "Total Product",
      sortable: true,
    },
    {
      key: "webview",
      text: "Web Publish",
      align: "left",
      cell: (record) => {
        return (
          <React.Fragment>
            <span
              className={`material-icons-outlined ${
                record.webview === "1" ? "text-success" : ""
              }`}
            >
              public
            </span>
          </React.Fragment>
        );
      },
    },
    {
      key: "bar",
      text: "Place",
      align: "left",
      cell: (record) => {
        return (
          <React.Fragment>
            <span
              className={`material-icons-outlined ${
                record.bar === "1" ? "text-success" : ""
              }`}
            >
              local_bar
            </span>
            <span
              className={`material-icons-outlined ${
                record.kitchen === "1" ? "text-success" : ""
              }`}
            >
              kitchen
            </span>
          </React.Fragment>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "table-actions",
      width: 150,
      sortable: false,
      align: "center",
      cell: (record) => {
        return (
          <React.Fragment>
            <button
              className="table-action btn btn-square btn-pure hover-info"
              onClick={() => <EditProduct product={record} />}
            >
              <span className="material-icons-outlined">visibility</span>
            </button>
            <Link
              className="table-action btn btn-square btn-pure hover-warning"
              to={`${url}/Edit/${record.catid}`}
            >
              <span className="material-icons-outlined">edit_note</span>
            </Link>
            <button
              className="table-action btn btn-square btn-pure hover-danger"
              onClick={() => {
                SetselectedId(record.id);
                SettriggerModal(true);
              }}
            >
              <span className="material-icons-outlined">delete</span>
            </button>
          </React.Fragment>
        );
      },
    },
  ];
  const config = {
    key_column: "id",
    page_size: 30,
    length_menu: [30, 60, 90],
    show_filter: true,
    show_pagination: true,
    button: {
      // excel: true,
      // print: true
    },
    language: {
      loading_text: "Please be patient while data loads...",
    },
  };
  const fetchHandler = () => {
    ApiConnect.get("/Module/Inventory/Category/Details")
      .then((response) => {
        let Category = response.data;
        dispatch({ type: "SET_INVENTORY_CATEGORY", payload: { Category } });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const SetviewerTrigger = () => {
    Setmodal(false);
  };
  return (
    <div className="container">
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <div className="card-body">
            <div className="dataTables_wrapper">
              <ReactDatatable
                className="table table-separated"
                config={config}
                records={categoryList}
                columns={columns}
              />
            </div>
            <DeletePop
              trigger={triggerModal}
              delUrl={`/Module/Inventory/Category/Delete?id=${selectedId}`}
              hideTrigger={SettriggerModal}
              fallAction={fetchHandler}
            />
            <FileViewer
              trigger={showModal}
              doc={selectedFile}
              hideTrigger={SetviewerTrigger}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
